





















































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import EventListAlertBar from '@superComponents/Event/EventListAlertBar'
import OrganizerEventListAlertBar from '@hostComponents/Event/EventListAlertBar'
import SponsorEventListAlertBar from '@sponsorComponents/Event/EventListAlertBar'
import Trigger from '@modules/ui/triggers/Trigger'
import OfferResourceList from '@superUI/ResourceList/OfferResourceList'
import VendorListingResourceList from '@superUI/ResourceList/VendorListingResourceList'
import AudienceCreativeResourceList from '@superComponents/AudienceCreative/AudienceCreativeResourceList'
import SpaceResourceList from '@superComponents/Space/SpaceResourceList'
import PayoutBankAccountResourceList from '@superUI/ResourceList/PayoutBankAccountResourceList'
# import RemittanceResourceList from '@superUI/ResourceList/RemittanceResourceList'
import FlagsAndTags from '@superUI/FlagsAndTags'
import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'
import SendOrganizerInvitationTriggerModal from '@triggers/Organizer/SendOrganizerInvitationTriggerModal'
import ChangeEmailTriggerModal from '@triggers/Member/ChangeEmailTriggerModal'
import TransferAudienceCreativesTriggerModal from '@triggers/AudienceCreative/TransferAudienceCreativesTriggerModal'
import SwitchMarketTypeTriggerModal from '@triggers/Organizer/SwitchMarketTypeTriggerModal'
import ExtendOffersExpirationTriggerModal from '@triggers/Offers/ExtendOffersExpirationTriggerModal'

settings =
  name: 'OrganizerShow'
  components: {
    SuperContainerView,
    Back,
    EventListAlertBar,
    'organizer-event-list-alert-bar' : OrganizerEventListAlertBar,
    'sponsor-event-list-alert-bar' : SponsorEventListAlertBar,
    Trigger,
    OfferResourceList,
    AudienceCreativeResourceList,
    SpaceResourceList,
    VendorListingResourceList,
    PayoutBankAccountResourceList,
    # RemittanceResourceList,
    FlagsAndTags,
    PricingTable,
    UpdatePricingModelTriggerModal,
    SendOrganizerInvitationTriggerModal,
    ChangeEmailTriggerModal,
    TransferAudienceCreativesTriggerModal,
    SwitchMarketTypeTriggerModal,
    ExtendOffersExpirationTriggerModal,
  }
  resources:
    item:
      resourceName: 'organizers'
      slug: 'organizers/:organizerId'
    offers:
      resourceName: 'offers'
      slug: 'organizers/:organizerId/offers'
      infinityScroll: true
    audience_creatives:
      resourceName: 'audience_creative'
      slug: 'organizers/:organizerId/audience_creatives'
      infinityScroll: true
    spaces:
      resourceName: 'spaces'
      slug: 'organizers/:organizerId/spaces'
      infinityScroll: true
    vendor_listings:
      resourceName: 'vendor_listing'
      slug: 'organizers/:organizerId/vendor_listings'
      infinityScroll: true
    organizer_invitations:
      resourceName: 'organizer_invitations'
      slug: 'organizer_invitations'
    payout_bank_accounts:
      resourceName: 'payout_bank_account'
      slug: 'organizers/:organizerId/payout_bank_accounts'
      infinityScroll: true
    # remittances:
    #   resourceName: 'remittances'
    #   slug: 'organizers/:organizerId/remittances'
    #   infinityScroll: true
  vue:
    props: ['organizerId']

    data: ->
      deactivateModal:
        modalOptions:
          title: 'Deactivate this organizer'
          button:
            label: 'Deactivate'
      reactivateModal:
        modalOptions:
          title: 'Reactivate this organizer'
          button:
            label: 'Reactivate'

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      deactivateTriggerResource: ->
        { key: 'item', triggerName: 'deactivate', component: this }

      reactivateTriggerResource: ->
        { key: 'item', triggerName: 'reactivate', component: this }

      transferTriggerResource: ->
        { key: 'item', triggerName: 'transfer_owned_events', component: this }

      transferTriggerPayload: ->
        { id: @item.id, organizer_id: null }

      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

      publicTagTriggerResource: ->
        { key: 'item', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'item', triggerName: 'untag', component: this }
      privateStatusFlagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_status_flag', component: this }
      unflagTriggerResource: ->
        { key: 'item', triggerName: 'unflag', component: this }

      actionsForPricingModel: ->
        {
          @hiUpdatePricingModelTrigger,
          @hiRemoveSpecialPricingTrigger
        }

      optionsForAudienceCreatives: ->
        organizerId: @item.id
        supplierId: @item.supplier.id

      actionsForAudienceCreatives: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEditAudienceCreatives
        preview: @previewAudienceCreative
        show: @showAudienceCreative
        edit: @editAudienceCreative
        promptToTransfer: @promptToTransferAudienceCreatives

      optionsForSpaces: ->
        supplierId: @item.supplier.id

      actionsForSpaces: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEditSpaces

      emailsSilenced: ->
        @item.emails_silenced

      smsOptIn: ->
        @item.sms_opt_in

      warningMessages: ->
        msgs = []
        msgs.push 'This organizer is currently deactivated.' if @item.deactivated
        msgs.push 'E-mail notifications are silenced.' if @emailsSilenced
        msgs.push 'Opted-In to receive text messages' if @smsOptIn
        msgs

    methods:
      transferModal: ->
        organizerOptions = @prime?.context?.organizers || []
        orgsOptions = @prime?.context?.orgs || []

        {
          modalOptions:
            title: 'Transfer events'
            inputField:
              label: 'Organizer'
              type: 'el-select'
              model: 'name'
            inputFields: [
              {
                model: 'supplier_id'
                type: 'el-select'
                label: 'Supplier'
                options: organizerOptions.map((org) ->
                  { id: org.id, name: org.name }
                )
              }
              {
                model: 'organizer_id'
                type: 'el-select'
                label: 'Organizer'
                options: orgsOptions.map((org) ->
                  { id: org.id, name: "#{org.first_name} #{org.last_name}" }
                )
              }
            ]
            button:
              label: 'Transfer'
        }

      hiVerifyOrganizer: ->
        action = if @item.recess_verified then 'recess_unverify' else 'recess_verify'
        @triggerResource 'item', action

      hiTransferEventSetTrigger: ->
        payloadOptions = {}
        modalOptions = { currentOrganizerId: @item.id }
        @$refs.transferEventSetTrigger.fire(payloadOptions, modalOptions)
      onEventSetsTransferEventSet: ->
        @$refs.transferEventSetTrigger.close()

      hiChangeContact: ->
        @$router.push { name: 'OrganizerTransferWizardPage', params: { organizerId: @item.id } }

      hiChangeEmailTrigger: ->
        payloadOptions = {}
        modalOptions = { email: @item.email }
        @$refs.changeEmailTrigger.fire(payloadOptions, modalOptions)
      onItemChangeEmail: ->
        @$refs.changeEmailTrigger.close()
        @fetch('item')

      hiSwitchMarketTypeTrigger: ->
        @$refs.switchMarketTypeTrigger.fire()
      onItemSwitchMarketType: (_, brandRep) ->
        @$refs.switchMarketTypeTrigger.close()
        @$router.push { name: 'BrandRepShowPage', params: { brandRepId: brandRep.id } }

      hiToggleEmailsSilenced: ->
        value = !@item.emails_silenced
        @triggerResource 'item', 'update_emails_silenced', { value }

      hiToggleSmsOptIn: ->
        value = !@item.sms_opt_in
        @triggerResource 'item', 'update_sms_opt_in', { value }

      badgePotential: (item) ->
        return 'unconfirmed' if item.potential_unconfirmed
        return 'confirmed' if item.potential_confirmed
        return 'denied' if item.potential_denied

      badgeState: (item) ->
        return item.state

      badgePublished: (item) ->
        if item.published then 'published' else 'unpublished'

      badgeHorizon: (item) ->
        item.horizon

      deactivateTriggerPayload: (item) ->
        payload =
          organizer_id: item.id,
        payload

      reactivateTriggerPayload: (item) ->
        payload =
          organizer_id: item.id,
        payload

      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      onItemTransferOwnedEvents: (data, response) ->
        @$router.push({ name: 'OrganizerShowPage', params: { organizerId: data.organizer_id } })
        @fetchAllResources()

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')
      onItemAddPublicTag: -> @fetch('item')
      onItemAddPrivateTag: -> @fetch('item')
      onItemUntag: -> @fetch('item')
      onItemAddPrivateStatusFlag: -> @fetch('item')
      onItemUnflag: -> @fetch('item')

      sendOrganizerInvitationTrigger: ->
        payload =
          organizer_id: @item.id
        @$refs.sendOrganizerInvitationTrigger.fire(payload)
      onOrganizerInvitationsSendOrganizerInvitation: ->
        @$refs.sendOrganizerInvitationTrigger.close()

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire(payloadOptions, modalOptions)
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'item', 'update_pricing_model', { pricing_model: pricingModel }
      onItemUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch('item')

      bulkEditAudienceCreatives: (audienceCreatives) ->
        query = { audienceCreatives }
        @$router.push { name: 'OrganizerAudienceCreativeBulkEditPage', query }

      previewAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'OrganizerAudienceCreativePreviewPage', params }

      showAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'AudienceCreativeShowPage', params }

      editAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        query = { step: 'experience' }
        @$router.push { name: 'AudienceCreativeEditPage', params, query }

      promptToTransferAudienceCreatives: (audienceCreatives) ->
        payloadOptions =
          audience_creative_ids: audienceCreatives.map((item) => item.id)
        modalOptions =
          currentOrganizerId: @item.id
          supplierId: @ctxSupplierOrg(@item).id
        @$refs.transferAudienceCreativesTrigger.fire(payloadOptions, modalOptions)
      onAudienceCreativesTransferCreatives: ->
        @$refs.transferAudienceCreativesTrigger.close()
        @$refs.audienceCreativeResourceList.refreshInfinityScroll()

      bulkEditSpaces: (spaces) ->
        query = { spaces }
        @$router.push { name: 'OrganizerSpaceBulkEditPage', query }

      promptToExtendOffersExpiration: (offers) ->
        payloadOptions = { offer_ids: offers.map((o) => o.id) }
        modalOptions = {}
        @$refs.extendOffersExpirationTrigger.fire(payloadOptions, modalOptions)
      onOffersExtendOffersExpiration: ->
        @$refs.extendOffersExpirationTrigger.close()
        @$refs.offerResourceList.clearSelection()

export default VueOptions.vue settings
